import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Sep 26 2018
 * @author SKu
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { List } from 'immutable';
import { CompetitorProductFilter, Overview, Pagination, ProductInfoFilter } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { DataPairingLayer } from '../../transportLayers/data-pairing/DataPairingLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { CompetitorProductLayer } from '../../transportLayers/product/CompetitorProductLayer';
import { ProductLayer } from '../../transportLayers/product/ProductLayer';
/**
 * Data Pairing Store
 * Fletching DataPairingDTO
 * and Recommended Stats
 */

export var DataPairingStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(DataPairingStore, _BaseStore);

  function DataPairingStore() {
    var _this;

    _classCallCheck(this, DataPairingStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataPairingStore).apply(this, arguments));
    _this.name = StoreName.DataPairing;
    _this.dataPairingLayer = new DataPairingLayer();
    _this.productLayer = new ProductLayer();
    _this.competitorProductLayer = new CompetitorProductLayer();
    _this.list = new Map();
    _this.stats = new Map();
    /**
     * Fetches count of recommended products for each category
     */

    _this.products = new Map();
    _this.productsOverview = new Overview(ProductInfoFilter.EMPTY, null, null, new Pagination(DataPairingStore.PAGE_SIZE, 0, null));
    /**
     * Fletches count of recommended products for each category
     */

    _this.competitorProducts = new Map();
    _this.competitorProductsOverview = new Overview(ProductInfoFilter.EMPTY, null, null, new Pagination(DataPairingStore.PAGE_SIZE, 0, null));

    _this.pair = function (data) {
      return _this.dataPairingLayer.pair(data);
    };

    _this.updatePairParameters = function (internalProductId, competitorProductId, ratio, charger) {
      return _this.dataPairingLayer.updatePairParameters(internalProductId, competitorProductId, ratio, charger).then(function (product) {
        runInAction(function () {
          _this.list.set(product.productInfo.id, product);
        });
      });
    };

    return _this;
  } // FIXME: the same issue - data: any

  /**
   * Fletches products for given categoryId
   * @param data - consist of CategoryId, productName(for filtering)
   * and flag paired(should be false for unpaired page, true for recommended and paired pages)
   */


  _createClass(DataPairingStore, [{
    key: "getOverview",
    value: function getOverview(data) {
      var _this2 = this;

      return this.dataPairingLayer.getOverview(data).then(function (products) {
        runInAction(function () {
          _this2.list.clear();

          products.forEach(function (product) {
            _this2.list.set(product.productInfo.id, product);
          });
        });
      });
    }
    /**
     * Fletches count of recommended products for each category
     */

  }, {
    key: "getStats",
    value: function getStats() {
      var _this3 = this;

      this.stats.clear();
      return this.dataPairingLayer.getStats().then(function (stats) {
        runInAction(function () {
          stats.forEach(function (stat) {
            _this3.stats.set(stat.categoryId, stat);
          });
        });
      });
    }
  }, {
    key: "getProducts",
    value: function getProducts(categoryId, fullTextSearch, pageNum) {
      var _this4 = this;

      var productFilter = ProductInfoFilter.EMPTY.copy('textForSearch', fullTextSearch).copy('categoryId', categoryId);
      var pagination = new Pagination(DataPairingStore.PAGE_SIZE, DataPairingStore.PAGE_SIZE * (pageNum - 1), null);
      var overview = new Overview(productFilter, null, null, pagination); //

      return this.productLayer.getProductsFullTextSearch(overview).then(function (response) {
        runInAction(function () {
          _this4.productsOverview = response.overview;

          _this4.products.clear();

          response.result.forEach(function (productDTO) {
            if (productDTO.productInfo.id) {
              _this4.products.set(productDTO.productInfo.id, productDTO);
            }
          });
        });
      });
    }
  }, {
    key: "getCompetitorProducts",
    value: function getCompetitorProducts(fullTextSearch, ignored, competitorIds, pageNum) {
      var _this5 = this;

      var productFilter = CompetitorProductFilter.EMPTY.copy('textForSearch', fullTextSearch).copy('ignored', ignored).copy('competitorIds', competitorIds);
      var pagination = new Pagination(DataPairingStore.PAGE_SIZE, DataPairingStore.PAGE_SIZE * (pageNum - 1), null);
      var overview = new Overview(productFilter, null, null, pagination); //

      return this.competitorProductLayer.getCompetitorProductsFullTextSearch(overview).then(function (response) {
        runInAction(function () {
          _this5.competitorProductsOverview = response.overview;

          _this5.competitorProducts.clear();

          response.result.forEach(function (competitorProductDTO) {
            if (competitorProductDTO.competitorProduct.id) {
              _this5.competitorProducts.set(competitorProductDTO.competitorProduct.id, competitorProductDTO);
            }
          });
        });
      });
    }
  }]);

  return DataPairingStore;
}(BaseStore);
DataPairingStore.PAGE_SIZE = 1000;

__decorate([observable, __metadata("design:type", Map)], DataPairingStore.prototype, "list", void 0);

__decorate([observable, __metadata("design:type", Map)], DataPairingStore.prototype, "stats", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], DataPairingStore.prototype, "getOverview", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], DataPairingStore.prototype, "getStats", null);

__decorate([observable, __metadata("design:type", Map)], DataPairingStore.prototype, "products", void 0);

__decorate([observable, __metadata("design:type", Overview)], DataPairingStore.prototype, "productsOverview", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String, String, Number]), __metadata("design:returntype", Promise)], DataPairingStore.prototype, "getProducts", null);

__decorate([observable, __metadata("design:type", Map)], DataPairingStore.prototype, "competitorProducts", void 0);

__decorate([observable, __metadata("design:type", Overview)], DataPairingStore.prototype, "competitorProductsOverview", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String, Boolean, Object, Number]), __metadata("design:returntype", Promise)], DataPairingStore.prototype, "getCompetitorProducts", null);

__decorate([action, __metadata("design:type", Object)], DataPairingStore.prototype, "pair", void 0);